import "../../styles/product-detail.css";
import Footer from "../../components/footer";
import Header from "../../components/header";

function Brems() {
  return (
    <div>
      <Header />
      <div className="product-details">
        <div className="details-heading">
          <h1>BREMS</h1>
          <p>Brandone Revenue Enhancement and Monitoring System.</p>
        </div>
        <div className="details-body">
          <p>
            Brandone revenue enhancement and monitoring system (BREMS) - is a
            suite of application for collection of revenue by federal, state and
            local government. The core component of the solution is the payment
            platform. It connects all the collection centers (banks and other
            accredited locations) to a centralsystem using multiple redundant
            highly available links.
          </p>
        </div>
        <div className="details-features">
          <p>
            <span>Objectives</span>
          </p>
          <p>
            The objective of the solution is not only to increase the benchmark
            of federal, states or local governments' IGR, the flowing objectives
            are expected to be achieved by the system:
          </p>
          <ol>
            <li>
              <p>
                Simplification of payment process for rates, levies and taxes.
              </p>
            </li>
            <li>
              <p>
                To increase the level of Internally Generated Revenue
                significantly.
              </p>
            </li>
            <li>
              <p>
                Providing state with a comprehensive stratified tax payers data
                base.
              </p>
            </li>
            <li>
              <p>
                To block loopholes and leakages in all aspects of the State's
                revenue collection procedures.
              </p>
            </li>
            <li>
              <p>
                To ensure that the basis for the State's Federation Account
                Allocation is accurate since its IGR is a factor in determining
                its Federation Account Allocation.
              </p>
            </li>
            <li>
              <p>
                Generation of electronic receipts and Tax Clearance Certificate
                (e-TCC).
              </p>
            </li>
            <li>
              <p>
                Use of technology to automate all the processes involved in IGR.
              </p>
            </li>
          </ol>
        </div>
        <div className="details-features">
          <p>
            <span>Goals</span>
          </p>
          <p>
            It is aimed that at the end of the implementation of BREMS, the
            following goals will be achieved:
          </p>
          <ol>
            <li>
              <p>
                Development of an end-to end revenue collection and monitoring
                portal.
              </p>
            </li>
            <li>
              <p>
                Installation of IT facilities such as computers, printers,
                internet access and generators at the Tax stations.
              </p>
            </li>
            <li>
              <p>
                Distribution of customized Terminals/Card readers to designated
                places and Tax offices.
              </p>
            </li>
            <li>
              <p>
                Continuous maintenance of database to ensure data integrity.
              </p>
            </li>
            <li>
              <p>
                Staging of vigorous enlightenment campaigns to create public
                awareness.
              </p>
            </li>
            <li>
              <p>Training of resource persons for the project.</p>
            </li>
            <li>
              <p>Continuous cost-benefit analysis of the project.</p>
            </li>
            <li>
              <p>Gathering of accurate and timely Taxpayers Data.</p>
            </li>
            <li>
              <p>Provision of logistic support for the project.</p>
            </li>
          </ol>
        </div>
        <p className="details-cta">Request for demo and proposal today…</p>
      </div>
      <Footer />
    </div>
  );
}

export default Brems;
